import { CallOutlined, EmailOutlined, PhoneIphoneOutlined, TextsmsOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid-pro'

const AlertTablePanelNotifyPreferences = (cellParams: GridCellParams<DeviceAlertPanelTableRow, DeviceAlertPanelTableRow['preferences']>) => {
  const cellValue = cellParams.value ?? []

  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      {cellValue.includes('phone') && <CallOutlined fontSize="small" color="primary" aria-label="Phone Preference Enabled" />}
      {cellValue.includes('email') && <EmailOutlined fontSize="small" color="primary" aria-label="Email Preference Enabled" />}
      {cellValue.includes('sms') && <TextsmsOutlined fontSize="small" color="primary" aria-label="SMS Preference Enabled" />}
      {cellValue.includes('push') && <PhoneIphoneOutlined fontSize="small" color="primary" aria-label="Push Preference Enabled" />}
    </Box>
  )
}

export default AlertTablePanelNotifyPreferences
